import React from "react";
import { Box, Fab } from "@mui/material";
import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";
import CheckIcon from "@mui/icons-material/Check";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";

import { getSettingState } from "../../../redux/features/settingSlice";
import CustomCircleButton from "../CustomCircleButton";

const HeaderRecorder = ({ disabled }) => {
  const navigate = useNavigate();
  const { darkMode } = useSelector(getSettingState);

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "8px 16px 8px 16px",
        // backgroundColor: "white.main",
        position: "fixed",
        right: 0,
        left: 0,
        top: 0,
        zIndex: 2,
      }}
    >
      <CustomCircleButton
        onClick={(e) => {
          navigate(-1);
        }}
        width='48px'
        height='48px'
        bgColor='white.main'
        color='black.main'
        bShadow='none'
        border='2px solid'
        hoverBgColor='white.main'
        hoverColor='black.main'
        activeBgColor='black.main'
        activeColor='white.main'
      >
        <ArrowBackIosNewRoundedIcon sx={{ fontSize: "32px" }} />
      </CustomCircleButton>

      <Fab
        disabled={disabled}
        type='submit'
        sx={{
          border: "2px solid",
          borderColor: disabled ? "blackDisabled.main" : "black.main",
          backgroundColor: "white.main",
          color: "black.main",
          pr: "2px",
          boxShadow: "none",
          "&.MuiButtonBase-root:hover": {
            boxShadow: "none",
            border: "none",
            color: darkMode ? "white.main" : "",
          },
          "&.MuiButtonBase-root:active": {
            backgroundColor: "black.main",
            boxShadow: "none",
            color: "white.main",
            border: "none",
          },
        }}
        size='medium'
        aria-label='accept'
      >
        <CheckIcon sx={{ fontSize: "32px" }} />
      </Fab>
    </Box>
  );
};

export default HeaderRecorder;
